export default __webpack_public_path__ + "img/fyUKikBS.b12a2392.svg";